// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import React, { useState } from "react";
import { TModal } from "../../../../../../../types/common.type";
import { useQuery } from "react-query";
import values from "../../../../../../../values";
import api from "../../../../../../../api";
import {
  IFindTransaction,
} from "../../../../../../../types/common.interface";
import Context from "../../../../../../../context";
import FindDebtScreen from "..";
import utils from "../../../../../../../utils";
import { IPayDebtToDriver } from "../../../../../../../types/company.interface";

// import {useQuery} from "react-query";
// import {DebtContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const OnlineDriverTransactionContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedPayment, setSelectedPayment] = useState<any>();

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  const [requestOnlineDriverTransaction, setRequestOnlineDriverTransaction] =
    React.useState<IFindTransaction>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      isOnline:true,
      payerOriginType:"DRIVER",
      transactionStatus: 'SUCCESS',
    });

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const onlineDriverTransaction = useQuery(
    [
      values.useQueryKeys.onlineDriverTransaction,
      requestOnlineDriverTransaction,
      selectedYear?._id,
    ],
    () =>
      api.post.administrator.findTransaction({
        ...requestOnlineDriverTransaction,
        academicYear: selectedYear?._id,
      })
  );
  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <Context.OnlineDriverTransactionScreen.Provider
      value={{
        isLoading,
        showModal,
        setIsLoading,
        setShowModal,
        requestOnlineDriverTransaction,
        setRequestOnlineDriverTransaction,
        onlineDriverTransaction,
        selectedPayment,
        setSelectedPayment,
      }}
    >
      <FindDebtScreen rqData={onlineDriverTransaction} showModalData={{}} />
    </Context.OnlineDriverTransactionScreen.Provider>
  );
};

export default OnlineDriverTransactionContainer;
